import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../utils/api';
import moment from 'moment';
import './styles/StudentProfilePage.css';
import { useNavigate } from 'react-router-dom';

const StudentProfilePage = ({isSidebarCollapsed}) => {
    const { studentId } = useParams(); // Get the student ID from URL parameters
    const [student, setStudent] = useState(null);
    const [levelHistories, setLevelHistories] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchStudentDetails = async () => {
            try {
                const response = await api.get(`/student/profile/${studentId}`);
                setStudent(response.data.data.student || null);
                setLevelHistories(response.data.data.studentLevelHistoryList || null);
            } catch (error) {
                console.error("Failed to fetch student details", error);
            }
        };
        fetchStudentDetails();
    }, [studentId]);

    if (!student) return <p>Loading student details...</p>;

    const showPaymentButton = () => {
        const status = student.StudentStatuses[0].Status.status_name;
        if (status === 'NONACTIVE') return false; 
        else return true;
    };

    return (
        <div className={`page-content ${isSidebarCollapsed ? 'collapsed' : ''}`}>
            <div className="page-title">Student profile</div>
            <div className="form-container">
                <div className="section">
                    <h3 className="section-header">Student Data</h3>
                    <table>
                        <tbody>
                            <tr>
                                <td>Name</td>
                                <td>:</td>
                                <td>{student.student_name}</td>
                            </tr>
                            <tr>
                                <td>NIK</td>
                                <td>:</td>
                                <td>{student.student_code}</td>
                            </tr>
                            <tr>
                                <td>Birth Date</td>
                                <td>:</td>
                                <td>{moment(student.birth_date).format('DD MMMM YYYY')}</td>
                            </tr>
                            <tr>
                                <td>Branch</td>
                                <td>:</td>
                                <td>{student.Branch.branch_name}</td>
                            </tr>
                            <tr>
                                <td>Address</td>
                                <td>:</td>
                                <td>{student.address}</td>
                            </tr>
                            <tr>
                                <td>Join Date</td>
                                <td>:</td>
                                <td>{moment(student.join_date).format('DD MMMM YYYY')}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="section">
                    <h3 className="section-header">Contact Person Data</h3>
                    <div className="create-student-table">
                        <table>
                            <thead>
                            <tr>
                                <th className="no-column">No</th>
                                <th className='table-center-align'>Contact Person Name</th>
                                <th className='table-center-align'>Relationship</th>
                                <th className='table-center-align'>Phone Number	</th>
                            </tr>
                            </thead>
                            <tbody>
                            {/* Tampilkan data dari costs */}
                            {student.StudentContactPeople.map((cp, index) => (
                                <tr key={cp.student_contact_person_id}>
                                    <td>{index + 1}</td>
                                    <td>{cp.contact_person_name}</td>
                                    <td>{cp.relationship}</td>
                                    <td>{cp.phone_number}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="section">
                    <h3 className="section-header">Program Data</h3>
                    <table>
                        <tbody>
                            <tr>
                                <td>Program</td>
                                <td>:</td>
                                <td>{student.StudentLevels[0].mainProgram.program_name}</td>
                            </tr>
                            <tr>
                                <td>Level</td>
                                <td>:</td>
                                <td>{student.StudentLevels[0].Level.level_name}</td>
                            </tr>
                            <tr>
                                <td>Add On Program</td>
                                <td>:</td>
                                <td>{student.StudentLevels[0].addonProgram?student.StudentLevels[0].addonProgram.program_name : "-"}</td>
                            </tr>
                            <tr>
                                <td>Status</td>
                                <td>:</td>
                                <td>{student.StudentStatuses.map(status => status.Status.status_name).join(', ')}</td>
                            </tr>
                            <tr>
                                <td>Last Payment Date</td>
                                <td>:</td>
                                <td>{moment(student.Payments.map(payment => payment.payment_date).join(', ')).format('DD MMMM YYYY')}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="section">
                    <h3 className="section-header">Level History</h3>
                    <div className="create-student-table">
                        <table>
                            <thead>
                            <tr>
                                <th className="no-column">No</th>
                                <th className='table-center-align'>Program</th>
                                <th className='table-center-align'>Level</th>
                                <th className='table-center-align'>Start Level</th>
                                <th className='table-center-align'>Finish Level</th>
                            </tr>
                            </thead>
                            <tbody>
                            {/* Tampilkan data dari costs */}
                            {levelHistories.map((history, index) => (
                                <tr key={history.student_level_history_id}>
                                <td>{index + 1}</td>
                                <td>{history.Level.Program.program_name}</td>
                                <td>{history.Level.level_name}</td>
                                <td>{moment(history.start_date).format('DD MMMM YYYY')}</td>
                                <td>{history.end_date ? moment(history.end_date).format('DD MMMM YYYY') : 'Present'}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                
                <div className="button-group-profile">
                    <button className="profile-button" onClick={() => navigate(`/student/edit/${student.student_id}`)}>Edit</button>
                    <button className="profile-button" onClick={() => navigate('/students')}>Back</button>
                    {showPaymentButton() && <button className="profile-button" onClick={() => navigate(`/spp-payment-details/${student.student_id}`)}>Payment</button>}
                </div>
            </div>
        </div>
    );
};

export default StudentProfilePage;
